import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { getGradeList } from "../../actions/Grade.action";
import AddClassworkPerformanceForm from "../../components/AddClassworkPerformanceForm/AddClassworkPerformanceForm";
import Layout from "../../components/shared/Layout/Layout";

const AddClassworkPerformancePage = ({ edit, grades, getGradeList }) => {
  const { id } = useParams();
  useEffect(() => {
    getGradeList();
  }, []);
  return (
    <div className="bg_light">
      <Layout title={`${edit ? "Edit" : "Add"} Classwork Performance`}>
        {edit && id && grades ? (
          <AddClassworkPerformanceForm grades={grades} />
        ) : (
          <AddClassworkPerformanceForm grades={grades ? grades : []} />
        )}
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  grades: state.grade.grade,
});

export default connect(mapStateToProps, { getGradeList })(AddClassworkPerformancePage);
